import { useRouter } from '@hooks/useRouter';

export const usePathname = () => {
  const { pathname } = useRouter();

  return pathname;
};
